/**
 * Typography
 * This is a wrapper component for Material-UI's `Typography` providing a `fontWeight` attribute to
 * adjust the size of the image. Currently only one additional size is necessary based on the
 * design documentation.
 */
import { default as MuiTypography } from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
const useStyles = makeStyles(({ typography }) => ({
    light: { fontWeight: typography.fontWeightLight },
    regular: { fontWeight: typography.fontWeightRegular },
    medium: { fontWeight: typography.fontWeightMedium },
    bold: { fontWeight: typography.fontWeightBold },
}));
export const Typography = props => {
    const classes = useStyles();
    const { children, className, fontWeight, ...rest } = props;
    return (React.createElement(MuiTypography, Object.assign({ className: clsx(className, fontWeight && classes[fontWeight]) }, rest), children));
};
//# sourceMappingURL=Typography.js.map